import TaxiCorporationPlanEntryBillingsRequest, {
  TaxiCorporationPlanEntryBillingsRequestQueryParams,
} from "./taxi-corporation-plan-entry-billings.request";

const createQueryParams = (
  request: TaxiCorporationPlanEntryBillingsRequest,
): TaxiCorporationPlanEntryBillingsRequestQueryParams => {
  return {
    limit: request.limit,
    offset: request.offset,
    billingModel: request.billingModel,
    cargoOrderHumanId: request.cargoOrderHumanId,
    dateSince: request.dateSince,
    dateTo: request.dateTo,
    driver: request.driver,
    fleetPartner: request.fleetPartner,
    humanId: request.humanId,
    order: request.order,
  };
};

const taxiCorporationPlanEntryBillingsRequestFactory = {
  createQueryParams,
};

export default taxiCorporationPlanEntryBillingsRequestFactory;
